import React from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import icon from '../Ecosystem/assets/ecosystem.png'
import icon2x from '../Ecosystem/assets/ecosystem@2x.png'
import Org from '../Ecosystem/Org'
import Orgs from '../Ecosystem/Orgs'
import Container from '~shared/Container'
import Clip from '~shared/Clip'
import Display from '~shared/Display'
import Topic from '~shared/Topic'
import ButtonWrapper from '~shared/ButtonWrapper'
import urls from '~utils/urls'
import PrestyledLink from '~shared/Link'

const Icon = styled.div``

const Content = styled.div`
    color: #0C009A;

    ${Topic.Title} {
        margin: 0;
        margin-bottom: 1.5rem;
        text-align: left;
    }

    ${Topic.Paragraph} {
        font-size: 1rem;
        margin-bottom: 2.5rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Topic.Title} {
            margin-bottom: 1rem;
        }

        ${Topic.Paragraph} {
            margin-bottom: 3.5rem;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Topic.Title} {
            margin-bottom: 1.5rem;
        }

        ${Topic.Paragraph} {
            font-size: 1.125rem;
            margin-bottom: 4rem;
        }
    }
`

const Header = styled.div`
    display: flex;
    flex-direction: column;

    ${Content} {
        margin-top: 2.5rem;
    }

    @media (min-width: ${TABLET}px) {
        flex-direction: row-reverse;
        justify-content: space-between;

        ${Icon} {
            margin-top: 1.5rem;
        }

        ${Content} {
            margin-top: 0;
            max-width: 328px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        align-items: center;

        ${Icon} {
            margin-top: 0;
        }

        ${Content} {
            max-width: 550px;
        }
    }
`

const OrgIcons = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    margin: 3.5rem 2rem 0;

    ${Org} {
        padding: 0;
        position: relative;
        height: 104px;

        ${Org.Icon} {
            background-color: #FFFFFF;
            height: 100%;
        }

        ${Org.AboutOrg} {
            padding: 0;
            top: 100%;
            width: calc(200% + 1.25rem);
        }

        :nth-child(4n) ${Org.AboutOrg} {
            left: auto;
            right: 0;
        }

        :hover ${Org.Icon} {
            background: #F5F5F5;
        }
    }

    @media (min-width: ${TABLET}px) {
        width: fit-content;
        margin: 6.5em auto 0;
        grid-template-columns: repeat(4, 148px);

        ${Org} {
            height: 112px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        margin-top: 10.5rem;
        grid-template-columns: repeat(4, 215px);
        grid-column-gap: 1.25rem;
        grid-row-gap: 1.25rem;

        ${Org} {
            height: 170px;
        }
    }
`

const UnstyledEcosystem = (props) => (
    <div {...props}>
        <Container>
            <Header>
                <Icon $appear>
                    <Display mobile="block" tablet="none">
                        <Clip width={165} height={158} dy={0.03} rect={[0.78, 0.89]}>
                            <img src={icon} srcSet={`${icon2x} 2x`} alt="" />
                        </Clip>
                    </Display>
                    <Display mobile="none" tablet="block">
                        <Clip width={225} height={215} dx={0.105} dy={0.03} rect={[0.78, 0.89]}>
                            <img src={icon} srcSet={`${icon2x} 2x`} alt="" />
                        </Clip>
                    </Display>
                </Icon>
                <Content>
                    <Topic.Title $appear>
                        Streamr Ecosystem
                    </Topic.Title>
                    <div $appear>
                        <Display as={Topic.Paragraph} mobile="none" tablet="block">
                            Streamr collaborates with a number of other organisations in all kinds of ways.
                            Explore a few of our collaborations below or see the full Ecosystem on the dedicated page.
                        </Display>
                        <Display as={Topic.Paragraph} mobile="block" tablet="none">
                            Explore a few of our collaborations below or see the full Ecosystem on the dedicated page.
                        </Display>
                    </div>
                    <ButtonWrapper>
                        <Button
                            tag={PrestyledLink}
                            kind="primary"
                            size="big"
                            to={urls.project.ecosystem}
                            outline
                            noDecoration
                            noHover
                        >
                            Explore Ecosystem
                        </Button>
                    </ButtonWrapper>
                </Content>
            </Header>
        </Container>
        <Display mobile="block" tablet="none">
            <OrgIcons>
                <Orgs.Atarca />
                <Orgs.Bosch />
                <Orgs.Atos />
                <Orgs.Lynkeus />
                <Orgs.WWF />
                <Orgs.UnionBank />
            </OrgIcons>
        </Display>
        <Display mobile="none" tablet="block">
            <OrgIcons>
                <Orgs.PaveMotors />
                <Orgs.MAT />
                <Orgs.Atarca />
                <Orgs.Bosch />
                <Orgs.HPE />
                <Orgs.WWF />
                <Orgs.Atos />
                <Orgs.Lynkeus />
                <Orgs.UnionBank />
                <Orgs.TX />
                <Orgs.Swash />
                <Orgs.API3 />
            </OrgIcons>
        </Display>
    </div>
)

const Ecosystem = styled(UnstyledEcosystem)`
    @media (min-width: ${DESKTOP}px) {
        ${Container} {
            max-width: 58rem;
        }
    }
`

export default Ecosystem
